<div class="statement-generator-container">
  <div class="card">
    <div class="card-header">
      <h4>
        <mat-icon class="mr-2">auto_awesome</mat-icon>
        <!-- {{ 'components.statement-generator.title' | translate }} -->
        Statement Generator
      </h4>
    </div>

    <div class="card-body">
      <!-- Document Selection Section -->
      <div class="section mb-4">
        <h4 class="section-title">
          <!-- {{ 'components.statement-generator.select-documents' | translate }} -->
          Select Documents
      </h4>

        <div class="d-flex justify-content-between align-items-center mb-3">
          <button
            type="button"
            class="btn btn-outline-primary"
            style="border-color: #6c5ce7; color: #6c5ce7;"
            (click)="openDocumentSelector()">
            <mat-icon class="mr-1">attach_file</mat-icon>
            <!-- {{ 'components.statement-generator.select-documents-button' | translate }} -->
            Click to select documents
          </button>

          <button
            *ngIf="selectedDocuments.length > 0"
            type="button"
            class="btn btn-outline-secondary btn-sm"
            (click)="clearAll()">
            <mat-icon class="mr-1">clear_all</mat-icon>
            Clear all
            <!-- {{ 'generic.clear-all' | translate }} -->
          </button>
        </div>

        <!-- Selected Documents List -->
        <div *ngIf="selectedDocuments.length > 0" class="selected-documents">
          <div class="alert alert-info">
            <strong>{{ selectedDocuments.length }}</strong>
            {{ selectedDocuments.length === 1 ? 'Document attached' : 'Documents attached' }}
          </div>

          <div class="documents-list">
            <div
              *ngFor="let doc of selectedDocuments; let i = index"
              class="document-item d-flex justify-content-between align-items-center">
              <div class="document-info">
                <mat-icon class="text-muted mr-2">description</mat-icon>
                <span class="document-name">{{ doc.name }}</span>
                <small class="text-muted ml-2">({{ doc.type }})</small>
              </div>
              <button
                type="button"
                class="btn btn-sm btn-outline-danger"
                (click)="removeDocument(i)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- No Documents Selected -->
        <div *ngIf="selectedDocuments.length === 0" class="alert alert-warning">
          <mat-icon class="mr-2">info</mat-icon>
          <!-- {{ 'components.statement-generator.no-documents-selected' | translate }} -->
          No documents selected. Please attach documents to generate statements.
        </div>
      </div>

      <!-- Generate Button -->
      <div class="section mb-4">
        <button
          type="button"
          class="btn btn-lg"
          style="background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%); border: none; color: white;"
          [disabled]="selectedDocuments.length === 0 || isGenerating"
          (click)="generateStatements()">
          <mat-icon class="mr-2" *ngIf="!isGenerating">auto_awesome</mat-icon>
          <mat-spinner diameter="20" class="mr-2" *ngIf="isGenerating"></mat-spinner>
          <!-- {{ isGenerating ? ('components.statement-generator.generating' | translate) : ('components.statement-generator.generate-button' | translate) }} -->
          {{ isGenerating ? 'Generating...' : 'Generate Statements' }}
        </button>
      </div>

      <!-- Generated Statements Results -->
      <div *ngIf="generatedStatements.length > 0" class="section">
        <h6 class="section-title">
          <mat-icon class="mr-2">fact_check</mat-icon>
          Preview Generated Statements
        </h6>

        <div class="statements-results">
          <div class="results-header">
            <div class="header-cell statement-col">Statement</div>
            <div class="header-cell comment-col">Comment</div>
            <div class="header-cell loe-col">LoE</div>
            <div class="header-cell gor-col">GoR</div>
            <div class="header-cell ref-col">Reference</div>
          </div>

          <div class="results-body">
            <div *ngFor="let statement of generatedStatements; let i = index" class="result-row">
              <div class="result-cell statement-col">
                <div class="statement-content">
                  <div class="statement-number">#{{ i + 1 }}</div>
                  <div class="statement-text">{{ statement.statement }}</div>
                </div>
              </div>
              <div class="result-cell comment-col">
                <div class="comment-text">{{ statement.comment }}</div>
              </div>
              <div class="result-cell loe-col">
                <div class="evidence-level">
                  <span class="loe-badge level-{{ statement.loe }}">{{ statement.loe }}</span>
                  <small class="level-text">Level of Evidence</small>
                </div>
              </div>
              <div class="result-cell gor-col">
                <div class="recommendation-grade">
                  <span class="gor-badge grade-{{ statement.gor }}">{{ statement.gor }}</span>
                  <small class="grade-text">Grade of Recommendation</small>
                </div>
              </div>
              <div class="result-cell ref-col">
                <a [href]="statement.ref" target="_blank" class="reference-link">
                  <mat-icon>open_in_new</mat-icon>
                  <span>View Article</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="isGenerating" class="text-center py-4">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="mt-3 text-muted">
          <!-- {{ 'components.statement-generator.processing-documents' | translate }} -->
          Processing documents, please wait...
        </p>
      </div>
    </div>
  </div>
</div>
